// @flow

import React from "react";
import { localize } from "redux-i18n";

import actionCreators from "@modules/service/actionCreator";
import type { StepProps } from "@components";
import { SpecialContactsTypeFilter } from "@modules/service/components";
import type { SpecialContactsType } from "@modules/service/reducer/special-contacts-types/types";

type OwnProps = $Exact<{
  types: Array<SpecialContactsType>,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...StepProps,
  ...PropsFromLocalize,
}>;

export class Step1Configure extends React.Component<Props> {
  handleChange = (selectedId: number) => {
    if (!selectedId) {
      this.props.onChange({ id: 0 }, false);
    }

    const selected = this.props.types.find(t => t.id === selectedId);
    if (this.props.handleSubmit && selected) {
      this.props.handleSubmit(selected, true);
    }
  };

  render() {
    if (!this.props.editable) {
      return <div />;
    }

    return (
      <React.Fragment>
        <div className="w-100 d-flex justify-content-center">
          <div className="col-sm-5 py-5">
            <p className="text-grey">{this.props.t("SPECIAL_CONTACT_TYPE")}</p>
            <SpecialContactsTypeFilter
              types={this.props.types}
              defaultValue={(this.props.data || {}).id}
              onChange={this.handleChange}
            />
            <p className="mt-3 text-grey">{this.props.t("ADD_SPECIAL_CONTACT_STEP1_INFO")}</p>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default localize()(Step1Configure);
